import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const box = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  & > * {
    white-space: nowrap;
  }
`

export const dots = css`
  inline-size: 100%;
  border-block-end: ${spacing(0.125)} dashed;
  block-size: ${spacing(1.5)}; // 12px
  margin: ${spacing(0.25)} ${spacing(0.5)};
`
